export default __webpack_public_path__ + "static/media/regulatory--turn-right--g3.1d726512.png";